import { __ } from '@wordpress/i18n';
import { InnerBlocks, useBlockProps, InspectorControls } from '@wordpress/block-editor';
import {
	Placeholder,
	PanelBody,
	ToggleControl,
	RangeControl,
	SelectControl,
	__experimentalToggleGroupControl as ToggleGroupControl,
	__experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';

const Edit = ( props ) => {
	const blockProps = useBlockProps();

	const orderByData = [
		{ label: 'Newly published', value: 'post_date' },
		{ label: 'Title a-z', value: 'post_title' },
		{ label: 'Title z-a', value: 'post_title_desc' },
	];

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'learnpress-collections' ) }>
					<ToggleGroupControl
						label={ __( 'Layout', 'learnpress-collections' ) }
						value={ props.attributes.layout || 'gird' }
						onChange={ ( value ) => {
							props.setAttributes( {
								layout: value || 'gird',
							} );
						} }
						isBlock={ true }
					>
						<ToggleGroupControlOption value="list" label="Stack" />
						<ToggleGroupControlOption value="grid" label="Grid" />
					</ToggleGroupControl>
					<RangeControl
						label={ __( 'Posts per page', 'learnpress-collections' ) }
						value={ props.attributes.limit }
						onChange={ ( limit ) =>
							props.setAttributes( {
								limit: limit ?? 10,
							} )
						}
						min={ 1 }
						max={ 20 }
					/>
					<SelectControl
						label={ __( 'Order by', 'learnpress-collections' ) }
						value={ props.attributes.order_by }
						options={ orderByData }
						onChange={ ( order_by ) => {
							props.setAttributes( {
								order_by: order_by ?? 'post_date',
							} );
						} }
					/>
					<ToggleControl
						label={ __( 'Pagination', 'learnpress-collections' ) }
						checked={ props.attributes.pagination ? true : false }
						onChange={ ( value ) => {
							props.setAttributes( {
								pagination: value ? true : false,
							} );
						} }
					/>
				</PanelBody>
			</InspectorControls>
			<div { ...blockProps }>
				<Placeholder label={ __( 'Collection Listing (Legacy)', 'learnpress-collections' ) }>
					<div>
						{ __(
							'Display full content of Collection Listing, can not edit.',
							'learnpress-collections'
						) }
					</div>
				</Placeholder>
			</div>
		</>
	);
};

export default Edit;
